export const toolboxVariable = {
  'kind': 'category',
  'name': 'Variable',
  'categorystyle': 'variable_category',
  'custom': 'VARIABLE',
  'contents': [
  ],
}